<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "headingPlant" v-if="mode==='CREATE'">New Mobile App Version</md-dialog-title>
      <md-dialog-title class = "headingPlant" v-if="mode==='UPDATE'">Update Mobile App Version</md-dialog-title>
      <md-dialog-title class = "headingPlant" v-if="mode==='WEBCREATE'">New Web Version</md-dialog-title>
      <md-dialog-title class = "headingPlant" v-if="mode==='WEBUPDATE'">Update Web Version</md-dialog-title>
     
      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">

          <callingApiCenter  type="bar" :paths="['/api/w/app/list']"></callingApiCenter>
          <md-dialog-actions >
            <md-button class="md-raised" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Cancel</md-button>
            <md-button type="submit" class="md-raised md-primary"><span class="icons-center material-icons">create</span>Save</md-button>
          </md-dialog-actions>
      


          <div class = "down">
            <div class = "inputBoxDouble" >

              <div v-if="mode=='CREATE'" class = "inputBoxSpace">
                <md-field>
                  <label size="lg" class = "textlabel" for="appName">App Name</label>
                  <md-select v-model="dataForm.appName">
                    <md-option value="STC">STC</md-option>
                    <md-option value="CCIC">CCIC</md-option>
                  </md-select>
                </md-field>
              </div>

              <div v-if="mode=='WEBCREATE'" class = "inputBoxSpace">
                <md-field>
                  <label size="lg" class = "textlabel" for="appName">App Name</label>
                  <md-select v-model="dataForm.appName">
                    <md-option value="WEB">Web</md-option>
                  </md-select>
                </md-field>
              </div>

              <div v-if="mode=='UPDATE' || mode=='WEBUPDATE'"  class = "inputBoxSpace">
                <md-field>
                    <label>App Name</label>
                    <md-input v-model="dataForm.appName" disabled/>
                </md-field>
              </div>

              <div v-if="mode=='CREATE' || mode=='WEBCREATE'" class = "inputBoxSpace">
                <md-field >
                  <label size="lg" class = "textlabel" for="ver">Version</label>
                  <md-input name="ver" id="ver" autocomplete="new-password" v-model="dataForm.ver"/>
                </md-field>
              </div>

              <div v-if="mode=='UPDATE' || mode=='WEBUPDATE'"  class = "inputBoxSpace">
                <md-field >
                  <label size="lg" class = "textlabel" for="ver">Version</label>
                  <md-input v-model="dataForm.ver" disabled />
                </md-field>
              </div>
        
              <div  class = "inputBoxSpace" :class="getValidationClass('dataForm.releaseDate')">
                <datepicker v-model="dataForm.releaseDate">
                  <label>Release Date</label>
                </datepicker>
              </div>

              <div class = "inputBoxSpace">
                <md-field>
                  <label size="lg" class = "textlabel" for="status">Status</label>
                  <md-select v-model="dataForm.status">
                    <md-option value="DEVELOP">Development</md-option>
                    <md-option value="INACTIVE">Inactive</md-option>
                    <md-option value="ACTIVE">Active</md-option>
                  </md-select>
                </md-field>  
              </div>
            </div>

            <div class = "inputBoxDouble" >
              <div  class = "inputBoxSpace2">
                  <md-field >
                    <label size="lg" class = "textlabel" for="releaseNote">Version Note</label>
                    <md-input v-model="dataForm.releaseNote" />
                  </md-field>
                </div>
            </div>

            
          </div>
        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>

form {
  min-width: 1000px;
  margin: 5px;
}

.headingPlant {
  padding-top: 3;
  padding-left: 10;
  margin-bottom: 0;
  color: #24056a;
  line-height: 1;
  font-size: 30px;
  font-family: Roboto Slab;
}


.inputBoxDouble {
  width: 1000px;
  height: 80px;
  display: flex;
  flex-direction: row;
}

.inputBoxSpace {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 200px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 0;
}
.inputBoxSpace2 {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 800px;
  line-height: 1em;
  padding: 5px;
  margin-top: 0;
}



  
.cl .md-field{
  display: inline-block !important;
  width: auto;
  margin-bottom: 0;
  padding-top:0;
}

.cl .md-field .md-input {
  font-size: 14px !important;
}


</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import api from '../api';

    import dateFormat from '../utils/dateFormat';

    

  const getInitialdataForm = () => ({
    mode: null,
    appName: null,
    ver: null,
    env: null,
    status: null,
    releaseDate: null,
    releaseNote: null,
  });

 

  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      status: []
      
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),
      
    },

    validations: {
      dataForm: {
        appName: {required,},
        ver: {required,},
        status: {required,},
      },
    },

 
    methods: {

      openDialog(existingUser) {
        this.$store.commit('clearApiError');
      
        this.$v.dataForm.$reset();

        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
      
        if (existingUser) {
          this.dataForm = existingUser;
          this.dataForm.releaseDate = dateFormat.date(existingUser.releaseDate);
        }

        this.showDialog = true;
      },

      
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
  

      cancalAction(){
          this.showDialog = false;
          this.$store.commit('clearApiError');
      },


      async doSaveUser() {

        this.$v.dataForm.$touch();

        if (this.mode == "WEBCREATE" || this.mode == "CREATE")
        {this.dataForm.mode = "CREATE"}
        if (this.mode == "WEBUPDATE" || this.mode == "UPDATE")
        {this.dataForm.mode = "UPDATE"}   

        // this.dataForm.mode = this.mode
        this.dataForm.releaseDate = moment(this.dataForm.releaseDate).format('YYYY-MM-DD');

        if (this.$v.dataForm.$invalid) {
         this.$refs.top.$el.focus();
          return;
        }

        this.$store.dispatch('saveAppVersion', this.dataForm)
        .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            $('.btn-search-appVersion')
              .click();
          });


      },
    },
  };
</script>
